<template>
    <section id="projects-preview">
        <base-text v-if="heading" type="h4" class="heading">
            {{ heading }}
        </base-text>

        <section id="projects" :class="$mq">
            <div
                id="project"
                v-for="(project, index) in projects"
                :key="index"
                class="project"
            >
                <base-window>
                    <img
                        class="screenshot"
                        :src="project.screenshot"
                        :alt="project.name"
                    />
                </base-window>

                <div class="text">
                    <base-text type="h4" class="name">
                        {{ project.name }}
                    </base-text>
                    <base-text type="h5" class="developer">
                        {{ project.developer }}
                    </base-text>
                    <base-text type="p" class="description">
                        {{ project.description }}
                    </base-text>
                </div>

                <img
                    v-if="project.award"
                    class="award"
                    :src="project.award"
                    alt="award"
                />
            </div>
        </section>
    </section>
</template>

<script>
    export default {
        name: 'projects-preview',

        props: {
            heading: {
                type: String,
                required: false,
                default() {
                    return null;
                },
            },

            projects: {
                type: Array,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    #projects-preview {
        .heading {
            margin-bottom: 20px;
        }

        section#projects {
            display: grid;
            grid-gap: 0 50px;
            grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));

            .project {
                margin: 0 0 50px;
                position: relative;

                .screenshot {
                    width: 100%;
                }

                .text {
                    text-align: center;

                    .name {
                        margin-top: 15px;
                        font-size: 20px;
                    }

                    .developer {
                        margin-top: 5px;
                    }

                    .description {
                        margin-top: 10px;
                    }
                }

                .award {
                    width: 25%;
                    position: absolute;
                    right: -30px;
                    top: -30px;
                }
            }
        }
    }
</style>
